// src/services/dealerService.js
const dealers = [
    {
      id: 1,
      name: "Premium Auto Dealers",
      location: "123 Business Ave, New York, NY",
      phone: "+1 (555) 123-4567",
      email: "contact@premiumauto.com",
      rating: 4.7,
      reviewCount: 128,
      yearsActive: 12,
      services: [
        { name: "New Car Sales", icon: "🚗" },
        { name: "Pre-Owned Vehicles", icon: "🔧" },
        { name: "Financing", icon: "💰" },
        { name: "Service Center", icon: "🛠️" }
      ],
      recentReviews: [
        { user: "John S.", rating: 5, comment: "Excellent service!", date: "2 days ago" },
        { user: "Maria G.", rating: 4, comment: "Good experience", date: "1 week ago" }
      ],
      stats: {
        totalSales: 1240,
        monthlyAverage: 28,
        customerSatisfaction: 92
      },
      image: "/dealer1.jpg"
    },
    // ... (keep your other dealer data)
  ];
  
  export const getDealerById = (id) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(dealers.find(dealer => dealer.id === parseInt(id)));
      }, 300); // Simulate API delay
    });
  };
  
  export const getAllDealers = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(dealers);
      }, 300);
    });
  };